import React from "react";
import { RateScreen } from "./RateScreen";
import { useState } from "react";
import { SearchCustomer } from "./SearchCustomer";
import DynamicSelect from "../shared/DynamicSelect";
import { formatValidSelect } from "../../helpers/FormatHelper";
import NumberInput from "../shared/NumberInput";

export const CurrencyExchange = () => {

    const [customer, setCustomer] = useState('');
    const [showSearchCustomer, setShowSearchCustomer] = useState(false);
    const [metodoPago, setMetodoPago] = useState('');
    const [metodoEntrega, setMetodoEntrega] = useState('');
    const [numeroPago, setNumeroPago] = useState('');
    const [numeroEntrega, setNumeroEntrega] = useState('');
    const [isSwapped, setIsSwapped] = useState(false);


    const metodos =[
        {name:"Efectivo", value: "Efectivo"},
        {name:"Transferencia", value: "Transferencia"},
        {name:"Yape", value: "Yape"},
        {name:"Plin", value: "Plin"},
    ]

    const selectCustomer = (customerName) =>{
        setCustomer(customerName);
        setShowSearchCustomer(false);
    }

    const dropdownMetodoPagoChangeHandler = (item) => {
      if(item.value && item.value !== 'select')
      {
        setMetodoPago(item.value);
      }
      else
      {
        setMetodoPago('');
      }
    }

     const dropdownMetodoEntregaChangeHandler = (item) => {
      if(item.value && item.value !== 'select')
      {
        setMetodoEntrega(item.value);
      }
      else
      {
        setMetodoEntrega('');
      }
    }

    const onChangeNumeroPago = (event) => {
        setNumeroPago(event.target.value);
    }

    const onChangeNumeroEntrega = (event) => {
        setNumeroEntrega(event.target.value);
    }

    return <>
        <div className="uk-grid">
            <div  className="uk-width-1-2 uk-form-controls">
                <RateScreen updateIsSwapped={setIsSwapped}/>
            </div>
            <div  className="uk-width-1-2 uk-form-controls"></div>
            <div  className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{'Cliente:'}</label>
                <input className="uk-input" id="customer-name" value={customer} type="text" disabled={true} />                
            </div>
            <div className="uk-width-1-8 uk-form-controls">
                <button className="uk-button uk-button-green board-filter-button" type="button" onClick={()=>setShowSearchCustomer(true)}>Buscar</button>
            </div>

            <div  className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{'Cliente envía por'}</label>
                <DynamicSelect
                    className={formatValidSelect(true)}
                    listHasPlaceholder={false}
                    data={metodos}
                    placeholder={"Selecciona un método de pago"}
                    objValue={{value:metodoPago}}
                    getValue={dropdownMetodoPagoChangeHandler}/>      
            </div>

            
            <div  className="uk-width-1-4 uk-form-controls">
                {metodoPago !== '' && <>
                <label className="uk-form-label">{metodoPago === "Efectivo" ?"Monto":(metodoPago === "Transferencia"?"Número de cuenta":"Celular")}</label>
                {metodoPago === "Efectivo" &&
                    <NumberInput className="uk-input" placeholder="Monto a enviar" id="form-amount-received" type={isSwapped?"Integer":"Currency"}  />
                }
                {metodoPago !== "Efectivo" &&
                    <input className="uk-input" id="num-pago" value={numeroPago} type="text" onChange={onChangeNumeroPago}/>  
                }
                </>   
                }           
            </div>
            

            <div  className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{"Cliente recibe por"}</label>
                <DynamicSelect
                    className={formatValidSelect(true)}
                    listHasPlaceholder={false}
                    data={metodos}
                    objValue={{value:metodoEntrega}}
                    placeholder={"Selecciona un método de entrega"}
                    getValue={dropdownMetodoEntregaChangeHandler}/>      
            </div>
            
            <div  className="uk-width-1-4 uk-form-controls">
                {metodoEntrega !== '' && <>
                <label className="uk-form-label">{metodoPago === "Efectivo" ?"Monto":(metodoPago === "Transferencia"?"Número de cuenta":"Celular")}</label>
                {metodoPago === "Efectivo" &&
                    <NumberInput className="uk-input" placeholder="Monto a recibir" id="form-amount-received" type={isSwapped?"Currency":"Integer"}  />
                }
                {metodoPago !== "Efectivo" &&
                    <input className="uk-input" id="num-entrega" value={numeroEntrega} type="text" onChange={onChangeNumeroEntrega} /> 
                }
                </>
                }               
            </div>
            
            <div  className="uk-width-1-1 uk-form-controls" align="center" style={{marginTop:'20px'}}>
            <button id={'btn-order-add'}  key={'btn-order-add'} className="uk-button uk-button-green" >
                {'Enviar'}
            </button>
            </div>
        </div>
        <SearchCustomer showModal={showSearchCustomer} returnData={selectCustomer}/>

    </>
}